module.exports = __webpack_public_path__ + "static/media/J5.239dede8.jpg";